import type {
  PatientApi,
  BreaksApi,
  PatientApiUpdateQuery,
  TranscriptionApi,
} from "@/Modules/Patients/Models/Api";

import { get2, patch2, post2, remove2 } from "./utils/FunctionalTherapyApi";

export async function getPatients(): Promise<PatientApi[]> {
  return get2<void, PatientApi[]>(`/v1.0/clients`);
}

export async function getBreaks(uuid: string): Promise<BreaksApi> {
  return get2<void, BreaksApi>(`/v1.0/clients/${uuid}/breaks`);
}

export function getPatientById(uuid: string): Promise<PatientApi> {
  return get2<void, PatientApi>(`/v1.0/clients/${uuid}`);
}

export async function updatePatient(uuid: string, patientData: PatientApiUpdateQuery): Promise<PatientApi> {
  return patch2<PatientApiUpdateQuery, PatientApi>(`/v1.0/clients${uuid}`, patientData);
}

export function deletePatient(uuid: string): Promise<void> {
  return remove2<void, void>(`/v1.0/clients/${uuid}`);
}

export function requestTranscriptionEnablement(uuid: string): Promise<TranscriptionApi> {
  return post2<void, TranscriptionApi>(`/v1.0/clients/${uuid}/transcription`);
}

export function requestTranscriptionDisablement(uuid: string): Promise<TranscriptionApi> {
  return remove2<void, TranscriptionApi>(`/v1.0/clients/${uuid}/transcription`);
}

export function sendMissingEmail(uuid: string) {
  return post2<void, boolean>(`/v1.0/clients/${uuid}/missing-user`);
}

export function discharge(uuid: string, reason: string): Promise<unknown> {
  return post2<{ discharge_reason: string }, unknown>(`/v1.0/clients/${uuid}/discharge`, {
    discharge_reason: reason,
  });
}
